const CONFIG = {
    DEFAULT_LIFE_EXPECTANCY: 85,
    DEFAULT_INFLATION_RATE: 0.07,
    DEFAULT_INFLATION_RATE_STRING: "7%",
    DEFAULT_POST_RETIREMENT_RETURN: {"Balanced": 0.1, "Aggressive": 0.12, "Conservative": 0.09},
    DEFAULT_DEBT_RETURN: 0.06,
    EXPECTED_ROR: {"Balanced": 0.1, "Aggressive": 0.12, "Conservative": 0.09},
    EXPECTED_ROR_STRING: {"Balanced": "10%", "Aggressive": "12%", "Conservative": "9%"},
    DEFAULT_ASSET_ALLOCATION_IN_RETIREMENT: "Conservative",
    DEFAULT_ROR_IN_RETIREMENT: "9%",
    ug: {"Not Applicable": 0, "Reputed Indian": 3000000, "Premier Indian": 8000000, "Premier Overseas": 24000000},
    pg: {"Not Applicable": 0, "Reputed Indian": 2000000, "Premier Indian": 5000000, "Premier Overseas": 15000000},
    DEFAULT_ug_AGE: 18,
    DEFAULT_pg_AGE: 22,
    CURRENCY_SYMBOL: '₹',
    STORAGE_KEY: 'financial_wizard_data',
    QUALIFICATION_AMOUNT: 25000000,
    liquidDHI_Qualification: 7500000,
    liquidNetworth_Qualification: 7500000,
    networth_Qualification: 25000000,
    calendly_link: "https://calendly.com/plan-marcellus/asset-allocation-call"
  };
  
  export default CONFIG;
  
